import React, { useState } from 'react';
import { FaFacebook, FaTiktok, FaEnvelope, FaGlobe, FaCommentDots } from 'react-icons/fa';
import '../styles/Contact.css';

const Contact = () => {
  const [copied, setCopied] = useState('');

  const handleCopy = (text, label) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(label);
      setTimeout(() => setCopied(''), 2000);
    });
  };

  return (
    <div id="contact-page">
      <div className="contact-header">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you! Reach out via any of the channels below and we'll get back to you within 24 hours.</p>
      </div>

      <div className="contact-container">
        {/* Contact Cards */}
        <div className="contact-cards">

          <div className="contact-card primary">
            <div className="contact-card-icon"><FaCommentDots /></div>
            <h3>Facebook Messenger</h3>
            <p>Pinaka-mabilis na paraan para makausap kami. Message us anytime!</p>
            <a
              href="https://www.facebook.com/profile.php?id=61585468153192"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card-btn"
            >
              Message us on Messenger
            </a>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon"><FaEnvelope /></div>
            <h3>Email</h3>
            <p>For detailed inquiries, bookings, or concerns — email us directly.</p>
            <div className="contact-copy-row">
              <a href="mailto:sales@logicatechnology.com" className="contact-email-link">
                sales@logicatechnology.com
              </a>
              <button
                className="contact-copy-btn"
                onClick={() => handleCopy('sales@logicatechnology.com', 'email')}
                title="Copy email"
              >
                {copied === 'email' ? '✓ Copied!' : 'Copy'}
              </button>
            </div>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon"><FaFacebook /></div>
            <h3>Facebook Page</h3>
            <p>Follow us for updates, sample invitations, and promos.</p>
            <a
              href="https://www.facebook.com/profile.php?id=61585468153192"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card-btn outline"
            >
              Visit our Facebook Page
            </a>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon"><FaTiktok /></div>
            <h3>TikTok</h3>
            <p>Watch our invitation designs in action on TikTok.</p>
            <a
              href="https://www.tiktok.com/@logicatechnology"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card-btn outline"
            >
              Follow on TikTok
            </a>
          </div>

          <div className="contact-card">
            <div className="contact-card-icon"><FaGlobe /></div>
            <h3>Main Website</h3>
            <p>Learn more about Logica Technology and our other services.</p>
            <a
              href="https://logicatechnology.com"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-card-btn outline"
            >
              logicatechnology.com
            </a>
          </div>

        </div>

        {/* Response Time Note */}
        <div className="contact-note">
          <span>⏱️</span>
          <p>Our team typically responds within <strong>24 hours</strong>. For the fastest response, message us directly on <strong>Facebook Messenger</strong>.</p>
        </div>

        {/* FAQ quick links */}
        <div className="contact-faq">
          <h2>Quick Answers</h2>
          <div className="contact-faq-grid">
            <div className="faq-item">
              <h4>How much does it cost?</h4>
              <p>The standard E-Invitation package starts at <strong>₱800</strong>. Optional add-ons are available for rush handling, extra photos, printable files, and other special requests.</p>
            </div>
            <div className="faq-item">
              <h4>How do I pay?</h4>
              <p>We send payment details (GCash / bank transfer) via Messenger. 50% downpayment to start, remaining 50% upon approval.</p>
            </div>
            <div className="faq-item">
              <h4>How long does it take?</h4>
              <p>Standard delivery is <strong>2-3 days</strong> once complete and final event details are submitted. Rush handling is available as an add-on.</p>
            </div>
            <div className="faq-item">
              <h4>Can I request revisions?</h4>
              <p>Yes. Revision scope is confirmed during booking, and unlimited revisions are available as an optional add-on.</p>
            </div>
            <div className="faq-item">
              <h4>How do I share the invitation?</h4>
              <p>We provide a shareable link you can send via iMessage, Viber, Messenger, or post on social media.</p>
            </div>
            <div className="faq-item">
              <h4>Do you have a privacy policy?</h4>
              <p>Yes. We comply with the <strong>Data Privacy Act of 2012 (RA 10173)</strong>. Read our <a href="/privacy">Privacy Notice</a>.</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Contact;
